import { useEffect, useState } from "react";

export interface MaintenanceLangTexts {
  title: string;
  description: string;
  estimatedEnd: string;
  banner: string;
}

export interface MaintenanceConfig {
  maintenance: boolean;
  showBanner: boolean;
  endTime: string;
  es: MaintenanceLangTexts;
  en: MaintenanceLangTexts;
  pt: MaintenanceLangTexts;
}

const DEFAULT_TEXTS: MaintenanceLangTexts = {
  title: "",
  description: "",
  estimatedEnd: "",
  banner: ""
};

const DEFAULT_CONFIG: MaintenanceConfig = {
  maintenance: false,
  showBanner: false,
  endTime: "",
  es: DEFAULT_TEXTS,
  en: DEFAULT_TEXTS,
  pt: DEFAULT_TEXTS
};

/*function isValidLangTexts(obj: unknown): obj is MaintenanceLangTexts {
  if (!obj || typeof obj !== "object") return false;
  const d = obj as Record<string, unknown>;
  return (
    typeof d.title === "string" &&
    typeof d.description === "string" &&
    typeof d.estimatedEnd === "string" &&
    typeof d.banner === "string"
  );
}

function isValidConfig(data: unknown): data is MaintenanceConfig {
  if (!data || typeof data !== "object") return false;
  const d = data as Record<string, unknown>;
  return (
    typeof d.maintenance === "boolean" &&
    typeof d.showBanner === "boolean" &&
    typeof d.endTime === "string" &&
    isValidLangTexts(d.es) &&
    isValidLangTexts(d.en) &&
    isValidLangTexts(d.pt)
  );
}*/

export function useMaintenanceMode() {
  const [loading, setLoading] = useState(true);
  const [config, setConfig] = useState<MaintenanceConfig>(DEFAULT_CONFIG);

  useEffect(() => {
    /*fetch("/static/maintenance.json")
      .then((r) => (r.ok ? r.json() : DEFAULT_CONFIG))
      .then((data) => setConfig(isValidConfig(data) ? data : DEFAULT_CONFIG))
      .catch(() => setConfig(DEFAULT_CONFIG))
      .finally(() => setLoading(false));*/
    setConfig(DEFAULT_CONFIG);
    setLoading(false);
  }, []);

  return { loading, ...config };
}
